import { render, staticRenderFns } from "./Demographic.vue?vue&type=template&id=4e9351f3&scoped=true&"
import script from "./Demographic.vue?vue&type=script&lang=js&"
export * from "./Demographic.vue?vue&type=script&lang=js&"
import style0 from "./Demographic.vue?vue&type=style&index=0&id=4e9351f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9351f3",
  null
  
)

export default component.exports